import * as React from 'react';
import { CircularProgress, Backdrop } from '@mui/material';

export type LoadableProps = {
    open: boolean;
    onClose?: () => void;
    children: React.ReactNode;
    onlyBackdrop?: boolean;
};

const Loadable = ({ open, onClose = () => {}, children, onlyBackdrop = false }: LoadableProps) => (
    <div style={{ position: 'relative' }}>
        <Backdrop
            open={open}
            sx={{ color: '#FFFFFF', zIndex: (theme) => theme.zIndex.drawer - 1, position: 'absolute', opacity: '0.5 !important' }}
            onClick={() => onClose()}
        >
            {!onlyBackdrop && <CircularProgress color="inherit" />}
        </Backdrop>
        {children}
    </div>
);

export default Loadable;
